<template>
  <div class="calendar-widget">
    <!-- Calendar header with month navigation -->
    <div class="calendar-header">
      <button class="nav-button" @click="previousMonth">
       <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6462_116259)">
<path d="M9.99935 18.3307C14.6017 18.3307 18.3327 14.5998 18.3327 9.9974C18.3327 5.39502 14.6017 1.66406 9.99935 1.66406C5.39698 1.66406 1.66602 5.39502 1.66602 9.9974C1.66602 14.5998 5.39698 18.3307 9.99935 18.3307Z" stroke="#A4A7AE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 13.3307L13.3333 9.9974L10 6.66406" stroke="#A4A7AE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.66602 10H13.3327" stroke="#A4A7AE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_6462_116259">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>

      </button>
      <div class="current-month">{{ currentMonthName }} {{ currentYear }}</div>
      <button class="nav-button" @click="nextMonth">
       <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6462_116259)">
<path d="M9.99935 18.3307C14.6017 18.3307 18.3327 14.5998 18.3327 9.9974C18.3327 5.39502 14.6017 1.66406 9.99935 1.66406C5.39698 1.66406 1.66602 5.39502 1.66602 9.9974C1.66602 14.5998 5.39698 18.3307 9.99935 18.3307Z" stroke="#A4A7AE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 13.3307L13.3333 9.9974L10 6.66406" stroke="#A4A7AE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.66602 10H13.3327" stroke="#A4A7AE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_6462_116259">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>

      </button>
    </div>

    <!-- Days of week header -->
    <div class="weekdays">
      <div class="weekday" v-for="day in weekdays" :key="day.id">{{ day.day }}</div>
    </div>

    <!-- Calendar days -->
    <div class="days-grid">
      <div
        v-for="day in visibleDays"
        :key="day.date"
        class="day"
        :class="{
          'current-day': day.isCurrentDay,
          'other-month': !day.isCurrentMonth,
        }"
      >
        {{ day.dayNumber }}
        <div v-if="day.isCurrentDay" class="current-day-indicator"></div>
      </div>
    </div>

    <!-- Expand/collapse button -->
    <div class="expand-container">
      <button class="expand-button" @click="toggleExpanded">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline v-if="!expanded" points="6 9 12 15 18 9"></polyline>
          <polyline v-else points="18 15 12 9 6 15"></polyline>
        </svg>
      </button>
    </div>

    <!-- Appointment summary -->
    <div class="appointment-summary">
      <label class="checkbox-container">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 2V5"
            stroke="#555C74"
            stroke-width="0.7"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16 2V5"
            stroke="#555C74"
            stroke-width="0.7"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.5 9.08984H20.5"
            stroke="#555C74"
            stroke-width="0.7"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
            stroke="#555C74"
            stroke-width="0.7"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.6976 13.6992H15.7066"
            stroke="#555C74"
            stroke-width="0.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.6976 16.6992H15.7066"
            stroke="#555C74"
            stroke-width="0.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.9945 13.6992H12.0035"
            stroke="#555C74"
            stroke-width="0.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.9945 16.6992H12.0035"
            stroke="#555C74"
            stroke-width="0.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.29138 13.6992H8.30036"
            stroke="#555C74"
            stroke-width="0.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.29138 16.6992H8.30036"
            stroke="#555C74"
            stroke-width="0.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <span class="summary-text">
          You have no current jobs or requests
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import agentProfile from "../services/agentProfile";

export default {
  // props: {
  //   tabData: {
  //     type: Object, // or Array, String, etc.
  //     required: true
  //   }
  // },
  data() {
    return {
      totalReschedule: "",
      totalRequest: "",
      currentDate: new Date(),
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      expanded: false,
      appointments: '0',
      weekdays: [
        {
          day: 'M',
          id: 1
        },
        {
          day: 'T',
          id: 2
        },
        {
          day: 'W',
          id: 3
        },
        {
          day: 'T',
          id: 4
        },
        {
          day: 'F',
          id: 5
        },
        {
          day: 'S',
          id: 6
        },
        {
          day: 'S',
          id: 7
        }
      ],
      // weekdays: ["M", "T", "W", "T", "F", "S", "S"],
      visibleDaysCount: 7, // Initially show only first week
    };
  },

  created() {
    agentProfile
      .smartAgentProfile()
      .then((data) => {
        if (data?.success) {
          this.totalReschedule = data.scheduled;
          this.totalRequest = data.pending_request;
        } else {
          console.log("Agent data not found");
        }
      })
      .catch((error) => {
        console.log("Error", error);
      });
  },
  computed: {
    currentMonthName() {
      return new Date(this.currentYear, this.currentMonth, 1).toLocaleString(
        "default",
        { month: "long" }
      );
    },
    daysInMonth() {
      return new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
    },
    firstDayOfMonth() {
      let day = new Date(this.currentYear, this.currentMonth, 1).getDay();
      // Adjust for Monday as first day of week (0 = Monday, 6 = Sunday)
      return day === 0 ? 6 : day - 1;
    },
    allDays() {
      const days = [];
      const today = new Date();
      const isCurrentMonth =
        today.getMonth() === this.currentMonth &&
        today.getFullYear() === this.currentYear;
      const currentDay = today.getDate();

      // Previous month days to fill the first week
      const prevMonth = this.currentMonth === 0 ? 11 : this.currentMonth - 1;
      const prevMonthYear =
        this.currentMonth === 0 ? this.currentYear - 1 : this.currentYear;
      const daysInPrevMonth = new Date(
        prevMonthYear,
        prevMonth + 1,
        0
      ).getDate();

      for (let i = 0; i < this.firstDayOfMonth; i++) {
        const dayNumber = daysInPrevMonth - this.firstDayOfMonth + i + 1;
        days.push({
          date: `${prevMonthYear}-${prevMonth + 1}-${dayNumber}`,
          dayNumber,
          isCurrentMonth: false,
          isCurrentDay: false,
        });
      }

      // Current month days
      for (let i = 1; i <= this.daysInMonth; i++) {
        days.push({
          date: `${this.currentYear}-${this.currentMonth + 1}-${i}`,
          dayNumber: i,
          isCurrentMonth: true,
          isCurrentDay: isCurrentMonth && i === currentDay,
        });
      }

      // Next month days to fill the last week
      const nextMonth = this.currentMonth === 11 ? 0 : this.currentMonth + 1;
      const nextMonthYear =
        this.currentMonth === 11 ? this.currentYear + 1 : this.currentYear;
      const totalCells =
        Math.ceil((this.firstDayOfMonth + this.daysInMonth) / 7) * 7;

      for (
        let i = 1;
        i <= totalCells - this.firstDayOfMonth - this.daysInMonth;
        i++
      ) {
        days.push({
          date: `${nextMonthYear}-${nextMonth + 1}-${i}`,
          dayNumber: i,
          isCurrentMonth: false,
          isCurrentDay: false,
        });
      }

      return days;
    },
    visibleDays() {
      return this.expanded
        ? this.allDays
        : this.allDays.slice(0, this.visibleDaysCount);
    },
  },
  mounted() {
    // console.log("Tabs data", this.tabData);
    this.appointments = JSON.parse(localStorage.getItem("requests"));
  },
  methods: {
    previousMonth() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11;
        this.currentYear--;
      } else {
        this.currentMonth--;
      }
    },
    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0;
        this.currentYear++;
      } else {
        this.currentMonth++;
      }
    },
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style scoped>
.calendar-widget {
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.current-month {
  font-weight: 500;
  font-size: 16px;
}

.nav-button {
  background: none;
  border: none;
  cursor: pointer;
  color: #555c74;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
}

.nav-button:hover {
  background-color: #f3f4f6;
}

.weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  margin-bottom: 8px;
}

.weekday {
  font-size: 14px;
  color: #555c74;
  font-weight: 500;
}

.days-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
}

.day {
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-size: 14px;
  border-radius: 4px;
}

.day:hover {
  cursor: pointer;
}

.current-day {
  font-weight: 500;
}

.current-day-indicator {
  position: absolute;
  bottom: 2px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #1d4ed8;
}

.other-month {
  color: #d1d5db;
}

.expand-container {
  display: flex;
  justify-content: center;
  margin-top: 8px;
  margin-bottom: 16px;
}

.expand-button {
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
}

.expand-button:hover {
  background-color: #f3f4f6;
}

.appointment-summary {
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.checkbox-container {
  display: flex;
  align-items: center;
  position: relative;
  font-weight: 400;
  cursor: pointer;
  font-size: 14px;
  color: #555c74;
}

.summary-text {
  line-height: 1.5;
}
</style>
